<script lang="ts">
  import { OctagonMinus } from '@lucide/svelte'
  import Button from '../../button/Button.svelte'
  import Tooltip from '../../tooltip/Tooltip.svelte'
  import { sceneMode } from '../../../stores/scene-mode'
  import i18n from '../../../i18n'

  function onClick() {
    sceneMode.set('forbiddenZone')
  }
</script>

<Tooltip placement="top" title={$i18n.t('project.modes.forbiddenZone')}>
  <Button
    size="icon-sm"
    variant={$sceneMode === 'forbiddenZone' ? 'default' : 'ghost'}
    onclick={onClick}
  >
    <OctagonMinus />
  </Button>
</Tooltip>
